var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: '_item', base: xP.base, prototype: {
    init: function (params, control) {

      if ($.type(params) === 'string') {
        params = {on: params};
      }

      if (!control) {
        control = params.to;
      } else {
        this.to = control;
      }

      xP.dependencies._item.base.init.apply(this, arguments);

      var that = this,
        root = control.parent && control.parent()
          ? control.root() : null;

      var parse_controls = function (param, values) {
        if ($.type(param) !== 'array') {
          param = [param];
        }

        var result = new xP.list();
        for (var i = 0, ii = param.length; i < ii; i++) {
          if ($.type(param[i]) === 'string') {
            result.append(xP(param[i]), root);
          } else {
            result.append(param[i]);
          }
        }

        if (values !== undefined) {
          result.filter(function () {
            if (!this.$element.is('[value]')) {
              return true;
            } else {
              var i, ii = values.length;
              for (i = 0; i < ii; i++) {
                if ($.type(values[i]) === 'regexp') {
                  if (
                    this.$element.val()
                      .match(values[i])
                  ) {
                    return true;
                  }
                } else {
                  if (this.$element.val() == values[i]) {
                    return true;
                  }
                }
              }
            }
            return false;
          });
        }

        return result;
      };

      if (this.values !== undefined && $.type(this.values) !== 'array') {
        this.values = [this.values];
      }

      this.to = parse_controls(this.to, this.values);

      this.from = parse_controls(this.from);


      if ($.type(this.on) === 'string') {
        this.on = this.on.replace(
          /((?:\[(?:[^\[\]]+=(?:[^\[\]]|\[[^\[\]]*\])+|this|self)\])+)(\.?)/g,
          function () {
            var control;

            if (
              arguments[1] === '[this]'
              || arguments[1] === '[self]'
            ) {
              control = that.to;
            } else {
              control = xP(arguments[1], root);

              if (
                !control[0]
                && root && root.$element.is(arguments[1])
              ) {
                control = [root];
              }
            }

            that.from.append(control);

            var id = that.from.index(control[0]);

            if (id < 0) {
              // TODO: Может стоит отменить зависимость?
              xP.debug(
                '', 'error',
                arguments[1] + ' in dependence not found',
                that
              );

              return arguments[0];
            }

            return 'arguments["' + id + '"].'
              + (arguments[2] == '.'
                ? ''
                : (control[0] instanceof xP.controls.fields
                ? 'count'
                : 'val') + '()'
              );
          });

        eval('this.on = function(){return ' + this.on + '}');
      }

      if (!this.from.length) {
        this.from.push(control);
      }

      var destroy = function () {
        that.destroy();
      };

      this.suprocess = function () {
        that.process();
      };

      this.from.each(function () {
        this.change(that.suprocess);

        this.destroy(destroy);
      });

      var dependence_init_inquiry = that.type + '_init_inquiry';

      this.to.each(function () {
        var control = this, dependence = control[that.type];

        if (!dependence || !dependence.append) {
          dependence = control[that.type] = new xP.list();
        }

        dependence.append(that);

        // TODO: Нужно удалять только, когда удалены все контролы.
        control.destroy(destroy);

        //return;
        if (!control._param(dependence_init_inquiry)) {
          control._param(
            dependence_init_inquiry,
            xP.after(function () {
              dependence.each(function () {
                this.suprocess();
              });

              control._param(dependence_init_inquiry, null);
            }, 0)
          )
        }
      });

      xP.debug(
        'dependencies', 'dependence',
        this.type, this.to.first().$element, this
      );
    },

    destroy: function () {
      var that = this;

      if (this.from) {
        this.from.each(function () {
          this.change(that.suprocess, true);
        });
      }

      if (this.to) {
        this.to.each(function () {
          this[that.type] = null;
        });
      }

      this.from
        = this.to
        = this.on
        = this['do']
        = null;

      return this;
    },

    process: function () {
      this.result = this.on.apply(this, this.from);
    }

  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/_input.js
 ** module id = 39
 ** module chunks = 0
 **/